import { render, staticRenderFns } from "./ModalFormularioModulosPrograma.vue?vue&type=template&id=18a952eb&scoped=true"
import script from "./ModalFormularioModulosPrograma.vue?vue&type=script&lang=js"
export * from "./ModalFormularioModulosPrograma.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioModulosPrograma.vue?vue&type=style&index=0&id=18a952eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a952eb",
  null
  
)

export default component.exports